import { useSuspenseQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'
import { SEARCH_PARAMS } from '@/lib/searchParams'
import companyProfileService from '@/lib/services/companyProfileService'
import companyService from '@/lib/services/companyService'

type CompanyProfileParams = Pick<
  typeof SEARCH_PARAMS.companyProfile,
  'identifierType' | 'identifier'
>

/**
 * Shared so a caller that needs the profile once — to act on a company it only
 * knows the id of, say — can fetch it imperatively and still hit the same cache
 * as the components rendering it.
 */
export function companyProfileQueryOptions(params: CompanyProfileParams) {
  return {
    queryKey: QUERY_KEYS.companyProfile(params),
    staleTime: 5000,
    queryFn: () => {
      if (!companyProfileService.isValidIdentifierType(params.identifierType)) {
        throw new Error(`Invalid identifier type: ${params.identifierType}`)
      }

      return companyService.getCompanyProfile({
        identifier: params.identifier,
        identifierType: params.identifierType,
      })
    },
  }
}

export function useCompanyProfileQuery(params: CompanyProfileParams) {
  return useSuspenseQuery(companyProfileQueryOptions(params))
}
